import {
  fe
} from "./chunk.5J6XSOAX.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  Oe,
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-highlight-text-item/jb-highlight-text-item.scss?inline
var jb_highlight_text_item_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
p, h3 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h3 {
  font-size: var(--theme-typo-h3-mobile-fontsize, 1.375rem);
  line-height: var(--theme-typo-h3-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  h3 {
    font-size: var(--theme-typo-h3-desktop-fontsize, 1.625rem);
    line-height: var(--theme-typo-h3-desktop-lineheight, 2.25rem);
  }
}

p {
  font-size: var(--theme-typo-p-small-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-desktop-lineheight, 1.625rem);
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  text-align: center;
}

svg {
  margin-bottom: 16px;
  max-width: 80px;
}

h3 {
  margin-bottom: 12px;
}`;

// src/components/jb-highlight-text-item/jb-highlight-text-item.ts
var JbHighlightTextItem = class extends r2 {
  render() {
    return ke`
      ${this.svgIcon ? Oe`${fe(this.svgIcon)}` : D}
      ${this.headline ? ke`<h3>${this.headline}</h3>` : D}
      ${this.subline ? ke`<p>${this.subline}</p>` : D}
    `;
  }
};
JbHighlightTextItem.styles = r(jb_highlight_text_item_default);
__decorateClass([
  n()
], JbHighlightTextItem.prototype, "headline", 2);
__decorateClass([
  n()
], JbHighlightTextItem.prototype, "subline", 2);
__decorateClass([
  n()
], JbHighlightTextItem.prototype, "svgIcon", 2);
JbHighlightTextItem = __decorateClass([
  customElement("jb-highlight-text-item")
], JbHighlightTextItem);

export {
  JbHighlightTextItem
};
